
import React, { useReducer } from "react";
import axios2 from 'services/axios2';
import { withRouterJim } from "router/withRouterJim";

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import EstadoTarea  from "components/EstadoTarea";
import EstadoCalificado  from "components/EstadoCalificado";


import NuConfirm from "components/nubox/Box/NuConfirm";
import NuInput from "components/nubox/NuInput";
import ListFile2 from "components/ListFile2";
import NuFileUploadModal from "components/nubox/Box/NuFileUploadModal"
import NuLoading from 'components/nubox/NuLoading';

import pdficon from "assets/img/pdficon.png";




import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";


const initialForm = {
  idd:0,
  ope:'n',
  
  id_tareaest:0,

};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class TareaEstNuevo extends React.Component {
  state = {

    isloaging:false,
    modalShow: false,
    
    fecha:'',
    
    form: Object.assign({}, initialForm),
    tarea_est:{},


    tarea_file:[], /* lista de tareas presentadas */
    tarea_file_sel:{},
    dataList: [],/* lista  */
    //{"col":1, "label":'A1', 'id_asisfe':145 }
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //------------------
  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({dataList:[]});
    
    //let bimestre = this.props.params.id;
    //this.cargar_data();
    this.cargar_form();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    //let id_asisfe = this.props.params.id;
    
    
  }
  
  //-------------------------
  cargar_form = () => {
    //context API
    console.log("cargar_form");  
    let id = this.props.params.id
    //let materia = this.props.store.materia
    let user = this.props.store.user

    let param = { 
      id: id,
      id_est: user.id_est,
    }
    console.log(param); 
    axios2.post( "tarea_est_nuevo_get_form", param )
    .then(res => {
      
        //if(! this.isEmptyObject(res.data)){ 
        console.log(res.data.tarea_est)
            this.setState({form: res.data.form }); 
            this.setState({tarea_est: res.data.tarea_est}); 
            this.setState({tarea_file: res.data.tarea_file}); 

            //añadimos el id y ope
            /*this.setState({
              form: {  ...this.state.tarea_est, 
                filename: JSON.parse(),  
              },
            });*/
            //---------------
        

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
  /**************ADD ROW***************************** */
  add_row = ( miObj )=>{
    //eliminamos el row, falta hacer
    let valorNuevo= {...miObj };
    //valorNuevo.id=this.state.data.length+1;
    //valorNuevo.id=this.state.data.length;
    
    let lista= this.state.tarea_file;
    lista.push(valorNuevo);

    //console.log(miObj)
    this.setState({ tarea_file: lista});
    //setRows([...rows, { name: '', age: '' }]);
  }
  delete_row = (i)=>{
    const arrayCopy = this.state.tarea_file;
    arrayCopy.splice(i, 1);

    this.setState({ tarea_file : arrayCopy });// asigna todo el objeto
  }
  /******************************************** */
  /******************************************** */
  /******************************************** */
  //---buscamos los datos de un estudiante preinscrito
  buscarClick =(e)=>{
    console.log("buscarClick")
    e.preventDefault()

    console.log("buscar")
    this.setState({modalShow:true});
  }
  //-------------esto viene del filename ---------------
  //---- llega un array
  handleOK=(arrItems)=>{ 
    console.log("handleOK")
    console.log(arrItems);
    //console.log("cad="+cad)
    this.setState({ modalShow: false});
    //----------tenemos que asignar el array 
    //this.setState({ options: data });
    /*for ( let item of arrItems ) 
    {
      
      console.log( item );
      //---agregamos al array
      let obj = {
        value: item.filename,
        label: item.nombre,
      }
      //this.add_row(obj)
      //let cad = 
      
    }
    */
    this.save_files(arrItems)
    
  }

  handleCancel=()=>{ 
    this.setState({ modalShow: false});
  }
  //-----------------------------------------------------------
  eliminarClick=()=>{
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar los archivos?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        //---borramos todos los archivos
        this.delete_files()
        
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })
  }
  /************************************************ */
  //---------------------------
  save_files = (arrItems) => {
    console.log("save_files");  
    //let id = this.props.params.id
    //let user = this.props.store.user
    let id_tareaest = this.state.tarea_est.id_tareaest

    let param = { 
      id_tareaest: id_tareaest,
      filename: JSON.stringify(arrItems),
    }
    console.log(param); 
    axios2.post( "tarea_est_nuevo_save", param )
    .then(res => {
      
        console.log(res.data)
        if(res.data.exito==1){
          NotificationManager.success("Registrado con exito")
          this.cargar_form()
        }
        

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
  //----------------------------
  delete_files = () => {
    console.log("delete_files");  
    //let id = this.props.params.id
    //let user = this.props.store.user
    let id_tareaest = this.state.tarea_est.id_tareaest

    let param = { 
      id_tareaest: id_tareaest,
    }
    console.log(param); 
    axios2.post( "tarea_est_nuevo_delete_files", param )
    .then(res => {
      
        console.log(res.data)
        if(res.data.exito==1){
          NotificationManager.success("Eliminado con éxito")
          this.cargar_form()
        }
        

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
  //------------------------------
  render() {
    let materia = this.props.store.materia
    let user = this.props.store.user

    let form = this.state.form
    let tarea_est = this.state.tarea_est
    //let arr_tareas =  JSON.parse( tarea_est.filename)
    
    
    return(
      <div>
        {
          //JSON.stringify(this.state.tarea_est)
        }
        
        <div className="row">
          <div className="col-md-12">
            <fieldset className="group-border">
              <h5 className="row titulo3">Tarea</h5>
            </fieldset>
            <br />

            <div className="row">
              <div className="col-lg-4">
                <label className="control-label" for="titulo"><b>Titulo:</b></label>
              </div>
              <div className="col-lg-8">
                <label>{ this.state.form.titulo }</label>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-lg-4">
                <label className="control-label" for="descripciont"><b>Descripción:</b></label>
              </div>
              <div className="col-lg-8">
                <label><p>{ form.descrip }
                  <br/></p></label>
              </div>
            </div>

            <br />
            <div className="row">
                <div className="col-lg-4">
                  <label className="control-label" for="descripciont"><b>Fecha de entrega:</b></label>
                </div>
                <div className="col-lg-8">
                  <label>{ form.fecha_fin }</label>
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-lg-4">
                  <label className="control-label" for="descripciont"><b>Tiempo restante:</b></label>
                </div>
                <div className="col-lg-8">
                  <label className="text-danger"><b>                            </b>
                  </label>
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-lg-4">
                  <label className="control-label" for="descripciont"><b>Archivo adjunto:</b></label>
                </div>
                <div className="col-lg-8">
                  <label>                        </label>
                </div>
              </div>
              <br />

              <h5 className="row titulo3">Estado de entrega:</h5>
              <div className="row">

                <div className="col-lg-4">

                </div>
                <div className="col-lg-8">
                  <table className="tabla_plomo">
                    <tbody><tr>
                      <td>Estado</td>
                      <td>
                        <EstadoTarea
                          value= {tarea_est.id_estadot}
                         />
                      </td>
                    </tr>
                      <tr>
                        <td>¿Calificado?</td>
                        <td>
                          <EstadoCalificado
                            value= {tarea_est.calificado_sn}
                         />
                        </td>
                      </tr>
                      <tr>
                        <td>Nota:</td>
                        <td>{ tarea_est.nota }</td>
                      </tr>
                      <tr>
                        <td>Fecha entregado:</td>
                        <td>{ tarea_est.fecha_reg }</td>
                      </tr>

                    </tbody></table>
                </div>
              </div>
              <br />
              <h5 className="row titulo3">Presentar tarea</h5>

              <div className="row">
                <div className="col-md-6">
                  <div class="btn-group">
                    <Button className="btn btn-info"
                          onClick={ (e)=> this.buscarClick(e) }  >
                          <i className="fa fa-upload"></i>&nbsp;
                          Subir archivo
                    </Button>
                    &nbsp;
                    <Button className="btn btn-danger"
                          onClick={ (e)=> this.eliminarClick(e) }  >
                          <i className="fa fa-remove"></i>&nbsp;
                          Eliminar archivos
                    </Button>
                  </div>
                </div>
                <div className="col-md-8">
                  
                </div>
              </div>

               <br />
                <h5 className="row titulo3">Archivos presentados</h5>
                <div className="row">
                  <div className="col-md-8">
                    <ListFile2
                        name=''
                        options={  this.state.tarea_file }
                        value={this.state.tarea_file_sel}
                        showDelete={false}
                        showDown={false}
                        fileURL={process.env.REACT_APP_AFILES}
                      />
                  </div>
                </div>
              
              <br />

          </div>
        </div>
        

        <NotificationContainer />
        <NuConfirm ref={this.refNuConfirm} />

        <NuFileUploadModal modalShow={ this.state.modalShow } 
          titulo="Entrada" 
          handleOK={ this.handleOK } 
          handleCancel={ this.handleCancel } 
          
          />
      </div>
    )
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(TareaEstNuevo);